"use strict"

import React from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  overlay_runs_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.overlay.runs.title" }) : "Overlay Runs",
}

export default function OverlayRunsButton({
  op,
  graphIndex,
  availableRuns,
  plotEntry,
  overlayRuns,
  small,
  intl,
}) {
  return (
    <Button
      variant={"outline-primary"}
      className={`${op.special === "multi" ? "btn-selected" : ""}${small ? " btn-sm" : ""}`}
      disabled={
        !op.observations ||
        (op.special && op.special !== "multi") ||
        availableRuns.filter((r) => r.loading).length > 0
      }
      title={registration.overlay_runs_label(intl)}
      onClick={(e) => {
        e.preventDefault()
        overlayRuns(op, graphIndex, plotEntry)
      }}
    >
      <span className={"fa fa-random"} aria-hidden={"true"} />
    </Button>
  )
}
